import GraphQL from "../../api/graphql";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { make } from "vuex-pathify";

const state = {
    documentsFavoriteLists: [],
    currentPage: 1,
    term: "",
    selectedItems: []
};

const mutations = make.mutations(state);

const actions = {
    async fetch({ state, rootState }, idFavoriteList) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                {
                    favoriteListById(id: ${idFavoriteList}) {
                        documents {
                            id: id,
                            access_level,
                            title_default
                            pivot {
                                created_at
                            }
                        }
                    }
                }
            `,
            variables: {}
        });

        const documents = get(response, "data.favoriteListById.documents", []);

        let documentDetailsQuery = "";
        documents.forEach(({ id }) => {
            documentDetailsQuery += `
            _${id}: viewDocument(id: ${id}) {
                source {
                    title_default
                }
            }
            `;
        });

        if (documentDetailsQuery) {
            const documentDetailsResponse = await client.query({
                query: `
                    {
                        ${documentDetailsQuery}
                    }
                `,
                variables: {}
            });

            const documentFavoriteLists = [];
            documents.forEach(document => {
                const { id, access_level, title_default } = document;

                let data = {
                    id,
                    access_level,
                    created_at: document.pivot.created_at,
                    title_default
                };

                data.title_default = get(
                    documentDetailsResponse,
                    `data._${id}.source.title_default`
                );

                if (isEmpty(data.title_default)) {
                    data.title_default = "Sem Título";
                }

                documentFavoriteLists.push(data);
            });

            this.set(
                "documentsFavoriteLists/documentsFavoriteLists",
                documentFavoriteLists
            );
        }
            
    },
    reset() {
        this.set("documentsFavoriteLists/documentsFavoriteLists", []);
        this.set("documentsFavoriteLists/currentPage", 1);
        this.set("documentsFavoriteLists/term", "");
        this.set("documentsFavoriteLists/selectedItems", []);
    },
    async removeDocumentFavoriteList({ dispatch, rootState }, param) {
        const { document_id, favorite_list_id } = param;

        const ids = [];

        document_id.forEach(function(idDocument) {
            ids.push(Number(idDocument.id));
        });

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation {
                    removeDocumentsFromFavoriteList(data: {id: ${favorite_list_id}, documents: [${ids}]}) {
                        id
                    }
                }
            `,
            variables: {}
        });

        await dispatch("fetch", favorite_list_id);

        this.set("documentsFavoriteLists/selectedItems", []);
    },
    async addDocumentFavoriteList({ rootState }, params) {
        const { favoriteListId, documentsIds } = params;

        if (favoriteListId == 0) {
            throw new Error("É necessário informar a lista de favoritos.");
        }

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($favoriteListId: ID!, $documentsIds: [ID!]) {
                    addDocumentsInFavoriteList(data: {id: $favoriteListId, documents: $documentsIds}) {
                        id
                    }
                }
            `,
            variables: {
                documentsIds,
                favoriteListId
            }
        });
    }
};

export default { state, mutations, actions };
